import { ApiClient } from './client.js'
import { ARTIST_SEARCH, TRACK_SEARCH, TRACK_SEARCH_NL, TRACK_SEARCH_OPTIONS, PLAYLIST_SEARCH, SEARCH_BOX_SELECTIONS, SFX_SEARCH } from './resources.js'

const client = new ApiClient()

export default {
  searchOptionsTrack () {
    return client.get(TRACK_SEARCH_OPTIONS)
  },

  searchTracks (params) {
    return client.get(TRACK_SEARCH, { params })
  },

  // Natural-language search.
  searchTracksNaturalLanguage (params) {
    return client.get(TRACK_SEARCH_NL, { params })
  },

  // Thumbs up or down on a natural-language search, by the search_id its
  // response carried. vote is 'up', 'down', or null to clear it.
  voteOnNaturalLanguageSearch (searchId, vote) {
    return client.post(`${TRACK_SEARCH_NL}${searchId}/feedback/`, { vote })
  },

  searchSfx (params) {
    return client.get(SFX_SEARCH, { params })
  },

  searchArtists (params) {
    return client.get(ARTIST_SEARCH, { params })
  },

  searchPlaylists (params) {
    return client.get(PLAYLIST_SEARCH, { params })
  },

  // Record a pick from the tracks page search box: what was typed, and the
  // artist, playlist or filter value picked. For analytics only.
  logSearchBoxSelection (selection) {
    return client.post(SEARCH_BOX_SELECTIONS, selection)
  }
}
